import { Box, Button, SxProps, Typography, useTheme } from "@mui/material"
import { deepmerge } from "@mui/utils"
import { useTranslation } from "providers/i18n"
import { getIcon } from "utils/icon"
import { useHomeInstructionCards } from "extensions/iconsiam/hooks/home-instruction-cards/useHomeInstructionCards"

interface HomeGuideCardsProps {
  sx?: SxProps
}

const DEFAULT_CARDS = [
  {
    key: "store",
    icon: getIcon({
      image: "https://s3.venue.in.th/find_a_store_2_44a455251d.svg",
    }),
    label: "Find a Store",
    subLabel: "ค้นหาร้านค้า",
  },
  {
    key: "direction",
    icon: getIcon({
      image: "https://s3.venue.in.th/get_direction_2_1e6ec34b0f.svg",
    }),
    label: "Get Direction",
    subLabel: "นำทางไปยัง",
  },
  {
    key: "privilege",
    icon: getIcon({
      image: "https://s3.venue.in.th/privilege_promotion_2_ba40402068.svg",
    }),
    label: "Privilege & Promotion",
    subLabel: "สิทธิพิเศษและโปรโมชั่น",
  },
  {
    key: "reservation",
    icon: getIcon({
      image: "https://s3.venue.in.th/reservation_table_2_d26f2041e4.svg",
    }),
    label: "Reservation Information",
    subLabel: "ข้อมูลการจอง",
  },
]

export const HomeGuideCards = ({ sx }: HomeGuideCardsProps) => {
  const { t } = useTranslation()
  const theme = useTheme()
  const { enable, cards } = useHomeInstructionCards()

  const styleOverrides =
    theme.components?.["HomeGuideCards"]?.styleOverrides || {}
  const { root, card, cardIcon, cardLabel, cardSubLabel } = styleOverrides

  const items = cards.length
    ? cards.map(({ key, icon, label, subLabel }) => ({
        key,
        label,
        subLabel,
        icon: getIcon(icon),
      }))
    : DEFAULT_CARDS

  if (!enable) return null

  return (
    <Box sx={deepmerge(root, sx)}>
      {items.map(({ key, icon, label, subLabel }) => (
        <Button key={key} disableTouchRipple sx={card}>
          <Box sx={cardIcon}>{icon}</Box>
          <Typography sx={cardLabel}>{t(label)}</Typography>
          <Typography sx={cardSubLabel}>{t(subLabel)}</Typography>
        </Button>
      ))}
    </Box>
  )
}
